module.exports = __webpack_public_path__ + "static/media/placeholder.0a6e6a4e.jpg";